export default "__VITE_ASSET__QRv3lAqR__"